module.exports = "<h1>Administrace</h1>\n<app-data-manager [endpoints]=\"endpoints\" [base]=\"base\" [endpointSchemes]=\"endpointSchemes\"></app-data-manager>"